import * as React from 'react';

import Login from 'containers/molecules/Login';
import routes from 'defs/routes';
import { WithRouterType } from 'types/withRouter';

import withVirtualPageView from 'components/hoc/withVirtualPageView';
import { WithVirtualPageView } from 'components/hoc/withVirtualPageView';

const LOGIN_VIEW_REDIRECT_PATH = routes.dashboard.indexRoute.href;

type LoginViewProps = WithRouterType &
	WithVirtualPageView & {
		isAuthenticated: boolean;
	};

type LoginViewState = {
	shouldRenderView: boolean;
};

export class LoginView extends React.Component<LoginViewProps, LoginViewState> {
	public static displayName = 'LoginView';

	public tracked = false;
	public state = {
		shouldRenderView: false,
	};

	public componentDidMount() {
		const { isAuthenticated, history } = this.props;

		if (isAuthenticated) {
			history.push(LOGIN_VIEW_REDIRECT_PATH);
		}
	}

	public componentDidUpdate(prevProps: { isAuthenticated: boolean }) {
		const latestProps = this.props || prevProps;

		if (this.props.isAuthenticated) {
			latestProps.history.push(LOGIN_VIEW_REDIRECT_PATH);
		}
	}

	public render() {
		const { isAuthenticated, trackVirtualPageView } = this.props;

		if (!this.tracked) {
			trackVirtualPageView({});
			this.tracked = true;
		}

		return isAuthenticated ? null : <Login />;
	}
}

export default withVirtualPageView(LoginView);
